<template>
  <div class="errorbox-wrapper">
    <div class="errorbox card animated slideInLeft-enter">
      <div class="card-body">
        <div class="errorbox-header">
          <div class="header">Something went wrong!</div>
          <div class="close-button" @click="clearError()">x</div>
        </div>
        <div class="errorbox-content">
          <div class="text">
            Looks like something went wrong with your request. Please, contact Symrise and provide traceback located
            below to ensure the issue is resolved as quick as possible.
            <br/>
            We're sorry for the inconvenience.
          </div>
          <div class="json-wrapper">
          </div>
          <button class="copy-button btn" type="button" @click="copyToClipboard(traceback)">
            Copy to clipboard
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import generalActions from '../../store/modules/general/actionTypes'

export default {
  name: 'ErrorTraceback',
  props: {
    traceback: Object
  },
  methods: {
    ...mapActions({
      clearError: generalActions.CLEAR_ERROR
    }),
    copyToClipboard (obj) {
      const str = JSON.stringify(obj)
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.errorbox-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(100, 100, 100, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 312089;

  .errorbox {
    width: 860px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 2px solid #999999;
    border-radius: 4px;

    .card-body {
      padding: 52px;

      .errorbox-header {
        width: 100%;
        height: 30px;

        .header {
          font-family: 'Source Sans Pro', sans-serif;
          font-size: 24px;
          line-height: 28px;
          font-weight: 900;
          letter-spacing: 0;
        }

        .close-button {
          height: 20px;
          color: #A6ADB4;
          font-family: 'Roboto', sans-serif;
          font-size: 20px;
          line-height: 20px;
          font-weight: 900;
          letter-spacing: 0;
          position: absolute;
          top: 26px;
          right: 30px;
          cursor: pointer;
        }
      }

      .errorbox-content {
        display: flex;
        flex-direction: column;

        .text {
          margin: 20px 0;
          color: #A6ADB4;
          font-family: 'Source Sans Pro', sans-serif;
          font-size: 18px;
          line-height: 23px;
          font-weight: 700;
          letter-spacing: 0;
        }

        .json-wrapper {
          max-height: 520px;
          overflow: scroll;
        }

        .copy-button {
          margin-top: 20px;
          margin-left: auto;
          font-family: 'Open Sans', sans-serif;
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
          letter-spacing: 0;
          width: 201px;
          height: 48px;
          background-color: #F8F8F8;
          border-radius: 4px;
          color: $button-text;
          text-transform: uppercase;
          transition: all 0.2s linear;

          &:hover {
            border-color: #dedede;
            background-color: white;
          }
        }
      }
    }
  }
}
</style>
